import { Box, Text, TypographyBodySize } from "@seneca/senekit";

import { pixels, SCORE_MIN_TEXT_WIDTH } from "../../consts";
import ScoreIndicator from "../../ScoreIndicator";

type Props = {
  score?: number;
  scoreRatioDisplay: string;
  showScoreIndicator?: boolean;
  fontSize?: TypographyBodySize;
};

export default function ExamQuestionsProgressIndicator({
  score,
  scoreRatioDisplay,
  showScoreIndicator,
  fontSize = "small"
}: Props) {
  return (
    <Box
      display="flex"
      dataNoTranslate
      paddingY="small"
      justifyContent="flex-end"
    >
      {showScoreIndicator ? (
        <ScoreIndicator value={score}>
          <Box minWidth={pixels(SCORE_MIN_TEXT_WIDTH)}>
            <Text size={fontSize}>{scoreRatioDisplay}</Text>
          </Box>
        </ScoreIndicator>
      ) : (
        <Text size={fontSize}>{scoreRatioDisplay}</Text>
      )}
    </Box>
  );
}
